// Utilitaires calendrier
export const MONTH_NAMES = [
  "janvier", "février", "mars", "avril", "mai", "juin",
  "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];
export const MONTH_NAMES_SHORT = [
  "janv.", "févr.", "mars", "avr.", "mai", "juin",
  "juil.", "août", "sept.", "oct.", "nov.", "déc.",
];
export const DAY_NAMES_SHORT = ["lun", "mar", "mer", "jeu", "ven", "sam", "dim"];
export const DAY_NAMES_FULL = [
  "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche",
];

/** Retourne YYYY-MM-DD à partir d'une Date (heure locale). */
export function toISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Renvoie la liste des cellules d'un mois (avec null pour les cases vides).
 * Semaine commence le lundi.
 */
export function getMonthCells(year, month) {
  const firstDay = new Date(year, month, 1);
  const firstWeekday = (firstDay.getDay() + 6) % 7; // Monday = 0
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstWeekday; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);
  return cells;
}

/** Génère la fenêtre glissante des N prochains mois à partir du mois courant. */
export function getNextMonths(count = 24, from = new Date()) {
  const months = [];
  const base = new Date(from.getFullYear(), from.getMonth(), 1);
  for (let i = 0; i < count; i++) {
    const d = new Date(base.getFullYear(), base.getMonth() + i, 1);
    months.push({ year: d.getFullYear(), month: d.getMonth() });
  }
  return months;
}

/** Regroupe les événements par jour, en dépliant les événements sur plusieurs jours. */
export function groupEventsByDay(events) {
  const map = new Map();
  for (const e of events) {
    const start = new Date(e.date + "T00:00:00");
    const end = e.end_date ? new Date(e.end_date + "T00:00:00") : start;
    const cur = new Date(start);
    // Sécurité : max 60 jours par événement
    let safety = 0;
    while (cur <= end && safety < 60) {
      const key = toISO(cur);
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(e);
      cur.setDate(cur.getDate() + 1);
      safety++;
    }
  }
  return map;
}

/** Format lisible d'une date : "lundi 3 mars 2026". */
export function formatFullDate(year, month, day) {
  const d = new Date(year, month, day);
  const dayName = DAY_NAMES_FULL[(d.getDay() + 6) % 7];
  return `${dayName} ${day} ${MONTH_NAMES[month]} ${year}`;
}
